import Vue from 'vue'
import Router from 'vue-router'
import fitting from '../views/fitting.vue'
import ship from '../views/ship.vue'
import login from '../views/login.vue' // 引入新页面组件
import index from '../views/index.vue' // 引入新页面组件
import khe from '../views/khe.vue' // 引入新页面组件
import flist from '../views/flist.vue' // 引入新页面组件
import fcl from '../views/fcl.vue' // 引入新页面组件
import finish from '../views/finish.vue' // 引入新页面组件
import fittings from '../views/fittings.vue' // 引入新页面组件
import free from '../views/free.vue' // 引入新页面组件
import edit from '../views/edit.vue' // 引入新页面组件
import dev from '../views/dev.vue' // 引入新页面组件
Vue.use(Router)

export default new Router({
	routes: [{
			path: '/finish',
			name: 'finish',
			component: finish
		},{
			path: '/fittings',
			name: 'fittings',
			component: fittings
		},{
			path: '/free',
			name: 'free',
			component: free
		},{
			path: '/dev',
			name: 'dev',
			component: dev
		},{
			path: '/fcl',
			name: 'fcl',
			component: fcl
		},{
			path: '/ship',
			name: 'ship',
			component: ship
		},{
			path: '/flist',
			name: 'flist',
			component: flist
		}, {
			path: '/khe',
			name: 'khe',
			component: khe
		}, {
			path: '/',
			name: 'index',
			component: index
		},
		{
			path: '/home',
			name: 'home',
			component: index
		},
		{
			path: '/login',
			name: 'login',
			component: login
		},
		{
			path: '/fitting', // 新页面的路径
			name: 'fitting',
			component: fitting // 指向新页面组件
		},
		{
			path: '/edit', // 新页面的路径
			name: 'edit',
			component: edit // 指向新页面组件
		}
		// 其他路由配置...
	]
})